import { decomposeMatrix } from '../../matrix/decomposeMatrix';
import { InteractiveZoneCircle } from '../types';

export function getAttributesCircle(
  circle: SVGCircleElement,
  options?: { applyMatrixTransformToPosition?: boolean }
): InteractiveZoneCircle {
  const strokeWidth = circle.getAttribute('stroke-width');
  const transform = circle.getAttribute('transform');

  const cx = circle.getAttribute('cx');
  const cy = circle.getAttribute('cy');
  const r = circle.getAttribute('r');

  const attributes: InteractiveZoneCircle = {
    strokeWidth: Number.parseFloat(strokeWidth ?? '0'),
    r: Number.parseFloat(r ?? '0')
  };

  let cxValue = cx ? Number.parseFloat(cx) : undefined;
  let cyValue = cy ? Number.parseFloat(cy) : undefined;

  if (transform && options?.applyMatrixTransformToPosition) {
    const match = transform.match(/matrix\(([^)]+)\)/);
    if (match) {
      const values = match[1].split(' ').map(Number.parseFloat);
      if (values.length === 6) {
        const [, , , , e, f] = values;
        if (cxValue !== undefined) cxValue += e;
        if (cyValue !== undefined) cyValue += f;
      }
    }
  }

  if (cxValue !== undefined) attributes.cx = cxValue;
  if (cyValue !== undefined) attributes.cy = cyValue;

  const matrix = circle?.getCTM();
  if (matrix && transform) {
    const decomposedMatrix = decomposeMatrix(matrix);
    const roundedAngle =
      Math.round((decomposedMatrix.rotation + Number.EPSILON) * 100) / 100;
    const cssReverseRotation = `rotate(${roundedAngle} ${cx ?? 0} ${cy ?? 0})`;
    attributes.transform = !transform.includes('rotate(')
      ? `${transform} ${cssReverseRotation}`
      : '';
  } else if (transform) {
    attributes.transform = `${transform}`;
  }

  return attributes;
}
